<app-header-blank class="sticky top-0 z-50"></app-header-blank>

<main class="flex items-center justify-center p-4">
    <ng-content></ng-content>
</main>
